<template>
  <q-item
    v-bind="attrs"
    class="flex items-center justify-between p-8 border border-neutral-100/10 shadow-sm rounded"
  >
    <div class="flex items-center gap-8">
      <div
        class="size-40 rounded-md bg-neutral-20 grid place-items-center"
      >
        <q-icon
          name="svguse:#file_icon"
          class="size-24 text-neutral-70"
        />
      </div>

      <div class="space-y-2">
        <h3
          class="text-headline-4 text-neutral-100 truncate max-w-[15rem]"
        >
          {{ name }}
        </h3>
        <p class="text-paragraph-4 text-neutral-70">
          {{ formatFileSize(size) }} • {{ date ? date : '-' }}
        </p>
      </div>
    </div>

    <div class="flex items-center gap-12 justify-end">
      <div v-show="deleteRequest" class="flex flex-col items-end">
        <span
          class="text-headline-3 text-neutral-100 whitespace-nowrap"
        >
          Upload completo
        </span>
        <span class="text-paragraph-2 text-neutral-70">
          Arquivo salvo
        </span>
      </div>

      <OButton
        v-if="showDownloadBtn"
        icon="download"
        @click="() => blobDownloadFile(file.anexo)"
      />

      <OButton v-if="showDeleteBtn" @click="handleDeleteFile">
        <q-icon name="close" size="20" />
      </OButton>
    </div>
  </q-item>
</template>

<script setup>
import { blobDownloadFile } from 'utils/GLOBAL'
import { computed, useAttrs } from 'vue'
import { useQuasar } from 'quasar'
import ModalConfirm from 'components/Modal/ModalConfirm.vue'
import OButton from 'components/Button/OButton.vue'

const $q = useQuasar()
const attrs = useAttrs()

const { file, deleteRequest } = defineProps({
  file: { type: Object, required: true },
  showDeleteBtn: { type: Boolean, default: true },
  showDownloadBtn: { type: Boolean, default: false },
  deleteRequest: { type: Boolean, default: false },
})

const size = computed(
  () => file?.anexo_tamanho_read_only || file?.file?.size
)
const date = new Date().toLocaleDateString('pt-BR')
const name = computed(
  () =>
    file?.anexo_nome_read_only?.split('/').at(1) || file?.file?.name
)

function formatFileSize(size) {
  if (!size) return '-'

  const units = ['bytes', 'KB', 'MB', 'GB', 'TB']
  let unitIndex = 0

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024
    unitIndex++
  }

  return `${size?.toFixed(2)} ${units[unitIndex]}`
}

function handleDeleteFile() {
  if (deleteRequest) {
    $q.dialog({
      componentProps: {
        icon: 'delete_forever',
        title: 'Excluir arquivo',
        text: 'Tem certeza que deseja excluir este arquivo?',
      },
      component: ModalConfirm,
      cancel: true,
    }).onOk(() => {
      emits('click:remove-file', file.id)
    })
  } else {
    emits('click:remove-file', file.name)
  }
}

const emits = defineEmits(['click:remove-file'])
</script>
